import { DashboardLayoutV2Shell } from '@/components/DashboardLayoutV2';
import { DashboardShellContext } from '@/contexts/DashboardShellContext';

/**
 * Persistent authenticated shell — mounts once; child routes render via Outlet.
 * Avoids re-fetching layout data on every navigation.
 *
 * Provider must wrap the shell (not sit inside it as children): DashboardLayoutV2Shell
 * renders route content via useOutlet(), which bypasses React children.
 */
export default function AuthenticatedShell({ user, onLogout }) {
  return (
    <DashboardShellContext.Provider value={true}>
      <DashboardLayoutV2Shell user={user} onLogout={onLogout} />
    </DashboardShellContext.Provider>
  );
}
